import styled from "@emotion/styled";
import { sizes } from "../../../constants/spacing";
import { bannerTheme } from "./bannerTheme";
export const BannerIconContainer = styled("div")`
    // Ensure we wrap the Icon itself with no extra default spacing.
    display: inline-flex;
    color: ${_ref => {
  let {
    themeMode,
    type
  } = _ref;
  return `var(--sds--banner--icon-color--${type},${bannerTheme.iconColor[type](themeMode)})`;
}};
    margin: ${sizes.small}px 0 ${sizes.small}px ${sizes.small}px;
`;
//# sourceMappingURL=BannerIconContainer.js.map